export const loginErrorHandler = (response, setErrorRequest) => {
  if (response.data) {
    if (
      response.data['error_description'] != null ||
      response.data['error_description'] != undefined ||
      response.data['error_description'] != ''
    ) {
      if (response.status == 400 || response.status == 401)
        setErrorRequest('The username/password is invalid');
      if (response.status == 408) setErrorRequest('Request Timeout');
      if (response.status == 404) setErrorRequest('Not Found');
    } else setErrorRequest(response.data['error_description']);
  }
  if (response) {
    var ErrorHandler = response.toString();
    if (
      ErrorHandler != null ||
      ErrorHandler != undefined ||
      ErrorHandler != ''
    ) {
      if (ErrorHandler.includes('400') || ErrorHandler.includes('401'))
        setErrorRequest('The username/password is invalid');
      if (ErrorHandler.includes('408')) setErrorRequest('Request Timeout');
      if (ErrorHandler.includes('404')) setErrorRequest('Not Found');
      else setErrorRequest(response.data['error_description']);
    }
  }
};
